<template>
  <section class="fade-carousel">
    <div ref="fade-carousel" class="swiper fade-carousel__wrapper">
        <div class="swiper-wrapper fade-carousel__track">
          <slot></slot>
        </div>
    </div>
  </section>
</template>

<script>
import Swiper from 'swiper';
import { Pagination, Autoplay, EffectFade } from 'swiper/modules';
import observer from '../../partials/_lozad';

export default {
  name: 'fade-carousel',
  data: () => ({
    carousel: null,
    carouselOptions: {
      modules: [Pagination, Autoplay, EffectFade],
      slideClass: "swiper-wrapper > *",
      slidesPerView: 1,
      autoplay: {
        delay: 3000,
      },
      speed: 2000,
      spaceBetween: 0,
      effect: "fade",
      crossFade: true,
      loop: true
    }
  }),
  methods: {
    async initCarousel() {        
        this.carousel = new Swiper(
            this.$refs["fade-carousel"],
            this.carouselOptions
        );  
    }
  },
  mounted() {
    this.initCarousel();
    observer.observe();
  }
};
</script>